var cesMenuItemClicked = function(menuItem) {
    var menuItemID = menuItem.id;
    
    if (menuItemID === 'whatsNewLink') {
    	$.showMessageDialog(msgObj);
    } else if (menuItemID) {
        window.location.href = $('base').attr('href') + $('#' + menuItemID).attr('href');
    } else {
        var target = $(menuItem.target);
        
        if (target) {
            if (target.hasClass('nav-button') && target.hasClass('help')) {
                window.open(infoCenterUrl + '?v=' + new Date().getTime());
            } else if (target.hasClass('istrobe-menu-item') || target.hasClass('fault-analytics-menu-item') || target.hasClass('abend-aid-menu-item') || target.hasClass('cjp-menu-item')) {
                window.location.href = target.attr('href');
            }
        }
    }
};

(function($) {
    var showMainContents = function() {
    	$('.main-contents').css('visibility', 'visible');
        $('.main-contents').hide().fadeIn(250);
    };
    
    $(document).ready(function() {
        $.createContextMenu('.nav-button.main-menu', '#mainMenu', 'mainMenu');
        showMainContents();
    });
})(jQuery);